/**
 * @description
 * Menus functions
 */

const bodyScrollLock = require('body-scroll-lock'),
    disableBodyScroll = bodyScrollLock.disableBodyScroll,
    enableBodyScroll = bodyScrollLock.enableBodyScroll;

export default function initMenus() {
    // Menu Footer
    $(document).on('click', '.dd-m-menu--footer .dd-m-menu__item--has-submenu > a', (e) => {
        e.preventDefault();

        const parent = $(e.target).closest('.dd-m-menu--footer .dd-m-menu__item--has-submenu');

        if (parent.hasClass('is-open')) {
            parent.find('> .dd-m-menu__submenu').slideUp('fast');
            parent.removeClass('is-open');
        } else {
            parent.addClass('is-open');
            parent.find('> .dd-m-menu__submenu').slideDown('fast');
        }
    });

    // Menu Header

    // Open menu
    $(document).on('click', '.dd-l-header__openmenu-btn', (e) => {
        e.preventDefault();

        $('#mainMenu').fadeIn('fast');
        disableBodyScroll(document.querySelector('#mainMenu'));
        $('body').addClass('dd-b-hidden');
    });

    // Open submenu
    $(document).on('click', '.dd-m-menu--top .dd-m-menu__item--has-submenu > .dd-m-menu__link', (e) => {
        e.preventDefault();

        const $el = $(e.target).closest('.dd-m-menu__item--has-submenu');

        $el.find('.dd-m-menu__submenu').fadeIn('fast');

        setTimeout(() => $el.addClass('is-opened'), 200);
    });

    // Back from submenu to menu
    $(document).on('click', '.dd-m-menu--top .dd-m-menu__back-btn', (e) => {
        e.preventDefault();

        const $el = $(e.target).closest('.dd-m-menu__submenu');

        $el.parent().removeClass('is-opened');
        $el.fadeOut('fast');
    });

    // Close menu
    $(document).on('click', '.dd-m-menu .dd-m-menu__close-btn', (e) => {
        e.preventDefault();

        let parent = $(e.target).closest('.dd-m-menu');

        parent.fadeOut('fast');
        parent.find('.dd-m-menu__submenu').parent().removeClass('is-opened')
        parent.find('.dd-m-menu__submenu').fadeOut('fast');
        bodyScrollLock.clearAllBodyScrollLocks();
        $('body').removeClass('dd-b-hidden');
    });
}



// WEBPACK FOOTER //
// ./resources/site/js/components/menus.js